import React, { useRef, useEffect, useState } from "react";
import {Box, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

import MaskSelectorToolStyles from "./MaskSelectorToolStyles";

import {
    brightcoveAccountId,
    brightcovePlayerId
} from "../../AppSettings";

import ovalOverlay from "../../components/mugshot/FaceMeasurer/img/gradient_frame_transparent.png";

import crossHair from "../../components/mugshot/FaceMeasurer/img/crosshair.png";
import doubleCrossHair from "../../components/mugshot/FaceMeasurer/img/double_crosshair.png";
import preScanVideoPoster from "./img/scanPoster3.png"

import { SHOW_DOUBLE_CROSSHAIR } from "../../components/mugshot/FaceMeasurer/MugShotConfig";

import {makeStyles} from "tss-react/mui";
import BackNextNavigation from "./BackNextNavigation";
import BrightcovePlayer from "../../BrightcovePlayer";


export const useStyles = makeStyles()((theme) => ({
    root: {
        textAlign: "center",
        position: "relative",
        width: "100%",
    },

    imgOverlayBox: {
        width: "100%",
        position: "absolute",
        overflow: "hidden",
        top: 0,
        left: 0
    },

    crossHairImg: {
        top: "-5px",
        left: 0,
        right: 0,
        bottom: 0,
        position: "absolute",
        zIndex: 100,
        width: "77%",
        height: "auto",
        margin: "auto",
    },

    frameImg: {
        zIndex: 180,
        position: "relative",
        top: 0,
        left:0,

    },

    frameImg2: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: "absolute",
        zIndex: 80,
    },

    portrait: {
        top: 0,
        bottom: 0,
        zIndex: 100,
    },

    overlay: {
        position: "absolute",
    },

    container: { position: "relative" },


    video: {
        padding: "0px",
    },

    doublePaddingBox: {
        marginTop: "6px"
    }

}));

const SizingScanPrepPage = ( { handleNext, handlePrevious } ) => {

    const[videoLoaded, setVideoLoaded] = useState(false);

    const { t } = useTranslation("pages.MaskSelectorTool.SizingScanPrepPage");

    const brightcovePreScanVideoUrlId = t("brightcovePreScanVideoUrlId");

    const instructions = t("instructions");

    const {classes} = MaskSelectorToolStyles();
    const {classes: localClasses} = useStyles();

    const textRef = useRef(null);

    useEffect(() => {
        if(textRef?.current) {
            textRef.current.focus();
        }
    });

    const buttonNavigationHeight = "62px";

    return (
        <Box sx={{minHeight: "calc(100svh - 53px)"}} >
            <Box sx={{minHeight: `calc(100% - ${buttonNavigationHeight})`}} className={`${classes.doublePaddingBox} ${classes.mainBox}`}>
                <Box sx={{minHeight: "100%"}} className={ `${classes.doublePaddingBox} ${localClasses.doublePaddingBox}` } >
                    <Box className={classes.containerBox}>
                        <Box className={localClasses.portrait}>

                                <BrightcovePlayer
                                    accountId={brightcoveAccountId}
                                    playerId={brightcovePlayerId}
                                    videoId={brightcovePreScanVideoUrlId}
                                    poster={preScanVideoPoster}
                                    loop={true}
                                    autoplay={true}
                                    onLoadedCallBack={() => {setVideoLoaded(true) } }
                                    controls={false}
                                />


                            <Box className={localClasses.imgOverlayBox}>
                                { videoLoaded ? (
                                    <>
                                        <img src={ovalOverlay} alt="" width="100%" height="100%" className={localClasses.frameImg}/>
                                        <img src={SHOW_DOUBLE_CROSSHAIR ? doubleCrossHair : crossHair } alt="" className={localClasses.crossHairImg}/>
                                    </>
                                ) : (
                                    <img src={preScanVideoPoster} alt="" width="100%" height="100%" className={localClasses.frameImg}/>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box className={classes.centeredBox}>
                <Typography className={`${classes.instruction} ${classes.noOutline}`} tabIndex="0" aria-label={instructions} ref={textRef}>{instructions}</Typography>
            </Box>
            <Box className={classes.buttonBox}>
                <BackNextNavigation handleNext={handleNext} handlePrevious={handlePrevious} />
            </Box>

        </Box>
    )
}

export default SizingScanPrepPage;